import React from "react"
import { Link } from "react-router-dom"
import { LinkProperty } from "../../@types/EpiFoundationSpa/Property"
import { urlIsInternal } from "../../utils"
import { sendDiscoverMoreDataLayerPush } from "../../utils/piwikPro"
import { DiscoverCard, DiscoverCardProps } from "./DiscoverCard"

export interface CapioNexusDiscoverBlockProps extends DiscoverCardProps {
	ctaLink: LinkProperty
}

const CapioNexusDiscoverBlock: React.FC<CapioNexusDiscoverBlockProps> = ({
	ctaLink: cta,
	heading,
	...rest
}) => {
	return cta ? (
		cta?.href && urlIsInternal(cta?.href) ? (
			<Link
				to={cta?.href ?? "#"}
				target={cta?.target}
				title={cta?.title}
				onClick={() => sendDiscoverMoreDataLayerPush(heading?.value)}
			>
				<DiscoverCard heading={heading} {...rest} />
			</Link>
		) : (
			<a
				href={cta?.href}
				onClick={() => sendDiscoverMoreDataLayerPush(heading?.value)}
				target="_blank"
				rel="noopener noreferrer"
			>
				<DiscoverCard heading={heading} {...rest} />
			</a>
		)
	) : (
		<DiscoverCard heading={heading} {...rest} />
	)
}

export { CapioNexusDiscoverBlock }
